
import { Component, Injectable, Inject, Input} from 'ng-metadata/core';

@Injectable()
export class PersonEntityPageService {
    constructor() {
    }    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/personEntityPage/personEntityPage.service.ts